import { EnumPersonaFisicaRequestDTORuolo } from '@framework/api-client/api/backoffice/schemas/enumPersonaFisicaRequestDTORuolo.ts';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { DossierPermissionRoleTag } from './DossierPermissionRoleTag.tsx';

interface IDossierPermissionRoleSelectInputProps {
  name: string;
}

const options = [
  {
    value: EnumPersonaFisicaRequestDTORuolo.EDITOR,
    label: (
      <DossierPermissionRoleTag
        role={EnumPersonaFisicaRequestDTORuolo.EDITOR}
      />
    ),
  },
  // Non è possibile selezionare il ruolo di titolare
  //   {
  //     value: EnumPersonaFisicaRequestDTORuolo.TITOLARE,
  //     label: (
  //       <DossierPermissionRoleTag
  //         role={EnumPersonaFisicaRequestDTORuolo.TITOLARE}
  //       />
  //     ),
  //   },
  {
    value: EnumPersonaFisicaRequestDTORuolo.VIEWER,
    label: (
      <DossierPermissionRoleTag
        role={EnumPersonaFisicaRequestDTORuolo.VIEWER}
      />
    ),
  },
];

/**
 * Componente di input di tipo select per la selezione del ruolo
 * nel cruscotto frontoffice (permessi di accesso alla pratica)
 */
export function DossierPermissionRoleSelectInput(
  props: IDossierPermissionRoleSelectInputProps,
) {
  const { name } = props;

  return <SelectInput name={name} allowClear options={options} />;
}
